import { defineMessages } from 'react-intl';

export default defineMessages({
  passwordStrengthAccessibilityHint: {
    id: 'password.strength.accessibility.hint',
    defaultMessage: 'Password strength:',
  },
  passwordStrengthLevel1: {
    id: 'password.strength.level.1',
    defaultMessage: 'Weak',
  },
  passwordStrengthLevel2: {
    id: 'password.strength.level.2',
    defaultMessage: 'Fair',
  },
  passwordStrengthLevel3: {
    id: 'password.strength.level.3',
    defaultMessage: 'Good',
  },
  passwordStrengthLevel4: {
    id: 'password.strength.level.4',
    defaultMessage: 'Strong',
  },
  passwordStrengthLevel5: {
    id: 'password.strength.level.5',
    defaultMessage: 'Very strong',
  },
  passwordStrengthUnavailable: {
    id: 'password.strength.unavailable',
    defaultMessage: 'Password strength unavailable',
  },
  passwordStrengthCantMatchEmail: {
    id: 'password.strength.cant.match.email',
    defaultMessage: "Password can't match email address",
  },
  passwordStrengthCantMatchDisplayName: {
    id: 'password.strength.cant.match.display.name',
    defaultMessage: "Password can't match display name",
  },
  passwordStrengthCantMatchAtlassianKeyword: {
    id: 'password.strength.cant.match.atlassian.keyword',
    defaultMessage: "Password can't match Atlassian keyword",
  },
  weakPasswordAdvice: {
    id: 'password.strength.weak.advice',
    defaultMessage: 'Avoid common phrases or try adding more characters',
    description: 'Advice given to users when their password is weak',
  },
  weakPassword: {
    id: 'password.strength.weak',
    defaultMessage: 'Weak password',
    description: "Message shown below a user's password entry to indicate it is weak",
  },
  fairPassword: {
    id: 'password.strength.fair',
    defaultMessage: 'Fair password',
    description: "Message shown below a user's password entry to indicate it is a fair strength",
  },
  goodPassword: {
    id: 'password.strength.good',
    defaultMessage: 'Good password',
    description: "Message shown below a user's password entry to indicate it is a good strength",
  },
  strongPassword: {
    id: 'password.strength.strong',
    defaultMessage: 'Strong password',
    description: "Message shown below a user's password entry to indicate it is strong",
  },
  veryStrongPassword: {
    id: 'password.strength.veryStrong',
    defaultMessage: 'Very strong password',
    description: "Message shown below a user's password entry to indicate it is very strong",
  },
});
